import { apiService } from './api';
import { PaginationParams } from '../types/common';
import { Price, PricesResponse } from '../types/diet';

class PriceService {
  async getPrices(params?: PaginationParams & { name?: string; status?: string; currency?: string }): Promise<PricesResponse> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.search) queryParams.append('search', params.search);
    if (params?.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params?.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    if (params?.name) queryParams.append('name', params.name);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.currency) queryParams.append('currency', params.currency);

    return apiService.get<PricesResponse>(`/prices?${queryParams.toString()}`);
  }

  async getPrice(id: string): Promise<{ price: Price }> {
    return apiService.get<{ price: Price }>(`/prices/${id}`);
  }

  async bulkUpdatePriceStatus(ids: string[], status: 'ACTIVE' | 'INACTIVE'): Promise<{ success: boolean; message: string; count: number }> {
    return apiService.post<{ success: boolean; message: string; count: number }>(`/prices/bulk-status`, { ids, status });
  }

  async exportPrices(params?: { search?: string; currency?: string; ids?: string[]; name?: string; status?: string }): Promise<Blob> {
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append('search', params.search);
    if (params?.currency) queryParams.append('currency', params.currency);
    if (params?.ids && params.ids.length) queryParams.append('ids', params.ids.join(','));
    if (params?.name) queryParams.append('name', params.name);
    if (params?.status) queryParams.append('status', params.status);

    const baseURL = process.env.REACT_APP_API_URL || '/api';
    const response = await fetch(`${baseURL}/prices/export?${queryParams.toString()}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      throw new Error('Export failed');
    }

    return response.blob();
  }
}

export const priceService = new PriceService();

